export async function syncCart(attributes) {
    const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes }),
    });
    console.log("syncCart response", response);
    const data = await response.json();
    return data;
}
export async function getCart() {
    const response = await fetch("/cart.js");
    const data = await response.json();
    return data;
}
export async function resetCart() {
    const response = await fetch("/cart/update.js", {
        method: "POST",
        body: JSON.stringify({ attributes: { real_id_check_id: "" } }),
    });
    const data = await response.json();
    return data;
}
